import axios from '../request/http';

const Login = {
  // 获取手机验证码
  getPhoneCode(params) {
    return axios.get("/api/login/send/phone_code", {
      params
    });
  },
  // 手机登录
  getphoneLogin(data) {
    return axios.post("/api/login/app_phone", data);
  },
  // 获取个人信息
  getuserinfo(params) {
    return axios.get("/api/user/info", {
      params
    });
  },
  // 绑定上级
  getbinding(params) {
    return axios.get("/api/user/superior/binding", {
      params
    });
  },
  // 获取微信授权签名参数
  getweixin(params) {
    return axios.get("/api/user/index/app/open", {
      params
    });
  },
  // 邀请好友助力优惠券信息
  assistDetail(params) {
    return axios.get("/api/box-coupon/assist/detail", {
      params
    });
  },
  // 邀请助力绑定邀请人
  assistBox(params) {
    return axios.get("/api/box-coupon/assist", {
      params
    });
  },
  // 邀请助力现助力列表
  nowAssistList(params) {
    return axios.get("/api/box-coupon/assist/H5-list", {
      params
    });
  },
  // 积分商城商品详情
  goodsdetail(params) {
    return axios.get("/api/goods/detail", {
      params
    });
  },
  // 积分商城商品规格信息
  goodsspec(params) {
    return axios.get("/api/goods/spec/list", {
      params
    });
  },
  // 积分商城商品规格信息
  goodsprice(data) {
    return axios.post("/api/goods/spec/price", data);
  },
  // 类型获取用户活动列表
  activityModuleListType(params) {
    return axios.get("/api/activityModule/list/type", {
      params
    });
  },
  //用户活动商品查询
  activityModuleQuery(params) {
    return axios.get("/api/activityModule/query", {
      params
    });
  },
  //用户活动列表
  activityModuleList(params) {
    return axios.get("/api/activityModule/list", {
      params
    });
  },
  // 活动信息详情
  activityModuleDetail(params) {
    return axios.get("/api/activityModule/detail", {
      params
    });
  },
  // 获取服务详情
  merservedetail(params) {
    return axios.get("/api/service/detail", {
      params
    });
  },
  // 获取商家服务卡详情
  weddingDetail(params) {
    return axios.get("/api/activity/combo/detail", {
      params
    });
  },
  // 商户评价列表
  merevaluate(params) {
    return axios.get("/api/service/evaluate/list", {
      params
    });
  },
  // 查询版本最新信息
  getNewestAppVersionInfo(params) {
    return axios.get("/api/user/index/version/check", {
      params
    });
  },

  // 查询详情
  getArticleInfo(params) {
    return axios.get("/api/article/details", {
      params
    });
  },
    // 查询版本最新信息
    getCommentList(params) {
      return axios.get("/api/articleComment/list", {
        params
      });
    },
}

export default Login;



// WEBPACK FOOTER //
// ./src/api/Login.js